export const ROUTE_LOGIN = '/login';
export const ROUTE_SIGN_UP = '/signup';
export const ROUTE_VERIFY_EMAIL = '/verify_email';
export const ROUTE_LOGOUT = '/logout';
export const ROUTE_RESET_PASSWORD = '/reset_password';
export const ROUTE_SET_PASSWORD = '/set_password';
export const ROUTE_SSO_INITIATED_LINK = '/sso_auth';
export const ROUTE_SSO_LOGIN = '/sso_login';

export const ROUTE_GET_DEMO = '/get_demo';

export const ROUTE_DASHBOARD = '/';
export const ROUTE_DATA_SOURCES = '/sources';

export const ROUTE_DATA_SETS = '/nexsets';
export const ROUTE_MY_DATA_SETS = '/nexsets/my_nexsets';

export const ROUTE_DATA_SETS_SHARED_WITH_ME = '/nexsets/shared_with_me';

export const ROUTE_DESTINATIONS = '/destinations';
export const ROUTE_PIPELINES = '/flows';
export const ROUTE_SELECT_PIPELINE_TYPE = '/flows/select-type';
export const ROUTE_CREATE_PIPELINE = '/flows/new';

export const ROUTE_TOOLS = '/tools';
export const ROUTE_DATA_MAPS = '/tools/lookups';
export const ROUTE_CREDENTIALS = '/tools/credentials';
export const ROUTE_ERROR_MANAGEMENT = '/tools/error_data_export';
export const ROUTE_REUSABLE_TRANSFORMS = '/tools/transforms';
export const ROUTE_RECORD_LINEAGE = '/tools/lineage';
export const ROUTE_SCHEMA_SPECS = '/tools/schemaSpecs';
export const ROUTE_API_KEYS = '/tools/apikeys';

export const ROUTE_SETTINGS = '/settings';
export const ROUTE_ACCOUNT_MANAGEMENT = '/settings/account';
export const ROUTE_NOTIFICATIONS_MANAGER = '/settings/notifications';
export const ROUTE_SUPPORT = '/support';

export const ROUTE_SUPPORT_VIDEOS = '/support/videos';

export const ROUTE_SHOW_TOKEN = '/token';
export const ROUTE_DOWNLOAD_CLI = '/download_cli';

export const ROUTE_NEXLA_DOCS = 'https://docs.nexla.com';

//OAUTH WINDOWS
export const ROUTE_DROPBOX_AUTH = '/dropboxAuth';
export const ROUTE_BOX_AUTH = '/boxAuth';
export const ROUTE_ZENDESK_AUTH = '/zendeskAuth';
export const ROUTE_INTUIT_AUTH = '/intuitAuth';
export const ROUTE_SSO_AUTH_LINK = '/sso';

export const ROUTE_OAUTH2_AUTH = '/oauth2Auth';
export const ROUTE_OAUTH_1A_AUTH = '/oauth1aAuth';

export const ROUTES_FOR_OAUTH = [
  ROUTE_DROPBOX_AUTH,
  ROUTE_BOX_AUTH,
  ROUTE_ZENDESK_AUTH,
  ROUTE_INTUIT_AUTH,
  ROUTE_OAUTH2_AUTH,
  ROUTE_OAUTH_1A_AUTH,
];

export const ROUTES_PUBLIC = [
  ROUTE_LOGIN,
  ROUTE_RESET_PASSWORD,
  ROUTE_SET_PASSWORD,
  ROUTE_SSO_INITIATED_LINK,
  ROUTE_SSO_LOGIN,
  ROUTE_SSO_AUTH_LINK,
  ROUTE_GET_DEMO,
];

/*Deprecated Routes*/
export const OLD_ROUTE_DATA_SETS_DERIVED = '/datasets/transformed';
export const OLD_ROUTE_DATA_SETS_FROM_MY_DATA = '/datasets/source_datasets';
export const OLD_ROUTE_DATA_SETS_PUBLIC = '/datasets/public';

/*Deprecated Dataset Routes V2*/
export const OLD_V2_ROUTE_DATA_SETS = '/datasets';
export const OLD_V2_ROUTE_MY_DATA_SETS = '/datasets/my_datasets';
export const OLD_V2_ROUTE_DATA_SETS_SHARED_WITH_ME = '/datasets/shared_with_me';

// TODO: redesign: remove when discarding old design
export const ROUTE_REDESIGN = '';
